import numeral from 'numeral';

export default function () {
    numeral.register("locale", "es-mx", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        currency: {
            symbol: "$"
        }
    })
}